import { render, staticRenderFns } from "./FormResponseType6.vue?vue&type=template&id=77b6c87d&scoped=true&"
import script from "./FormResponseType6.vue?vue&type=script&lang=js&"
export * from "./FormResponseType6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b6c87d",
  null
  
)

export default component.exports